module.exports = __webpack_public_path__ + "static/media/shark-leon.97fb25b9.png";